import { ElementRef } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export var WindowOnFocus: boolean = false;
export function setFocus(bool: boolean) { WindowOnFocus = bool; };

export class ZIndexMngr {
  private static zIndexMap: Map<ElementRef, number> = new Map();
  windowVisible: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor(protected elementRef: ElementRef) {}

  public dialogClosed(): void {
    this.windowVisible.next(false);
    ZIndexMngr.zIndexMap.delete(this.elementRef);
  }

  // Set Z index of given dialog to be the highest
  public dialogRaise(): void {
    let highestZIndex = 0;
    for (let dlg of ZIndexMngr.zIndexMap.keys()) {
      if (dlg != this.elementRef) {
        if (ZIndexMngr.zIndexMap.get(dlg) > highestZIndex)
          highestZIndex = ZIndexMngr.zIndexMap.get(dlg);
      }
    }
    if (ZIndexMngr.zIndexMap.get(this.elementRef) > highestZIndex) {
      highestZIndex = ZIndexMngr.zIndexMap.get(this.elementRef);
    }
    else {
      highestZIndex++;
      ZIndexMngr.zIndexMap.set(this.elementRef, highestZIndex);
    }
    this.elementRef.nativeElement.parentElement.parentElement.parentElement.style.zIndex = `${highestZIndex}`;
  }

  public windowClick(){
    this.dialogRaise();
    WindowOnFocus = true;
  }

}
